<div class="mobile_address_selection">

  <!-- Scrollable/flex content area -->
  <div class="content_area">

    <!-- Heading (map state only) -->
    <div class="heading" *ngIf="viewState === 'map'">
      <ng-container *ngIf="!citySearch">
        {{ 'navbar.find_best_options' | translate }}
      </ng-container>
      <ng-container *ngIf="citySearch">
        {{ 'address.confirm_address_with_recipient' | translate }}
      </ng-container>
    </div>
    <div class="subtitle" *ngIf="viewState === 'map' && citySearch">
      {{ 'address.enter_city_only' | translate }}
    </div>

    <!-- Search input -->
    <div class="search_input_wrapper">
      <img src="assets/images/icons/location_icon_for_search.svg" class="location_icon">
      <input #searchInputEl
             (input)="onSearchInput(searchInputEl.value)"
             [placeholder]="(citySearch ? 'address.enter_delivery_city' : 'address.enter_delivery_address') | translate"
             class="search_input">
    </div>

    <!-- Map section (kept in DOM, hidden during search so it stays initialised) -->
    <div class="map_section" [style.display]="viewState === 'search' ? 'none' : 'block'">
      <app-map
        #mapComponent
        [showCity]="citySearch"
        (mapReadyEvent)="mapReadyHandler()"
        [city]="$any(selectedAddressOrCity)"
        (selectedAddress)="selectAddressFromMap($event)"
      ></app-map>
    </div>

    <!-- Address search results -->
    <div class="results_list" *ngIf="viewState === 'search' && !citySearch">
      <div class="result_item pointer"
           *ngFor="let location of locations"
           (click)="selectAddressFromSearch(location)">
        <img src="assets/images/icons/location_Icon_for_mat_options.svg" class="result_icon">
        <div class="result_text">
          <span class="result_main">{{ location.streetAndHouse }}</span>
          <span class="result_sub">{{ location.cityAndRegion }}</span>
        </div>
        <img src="assets/images/icons/navbar/arrow_left_icon.svg" class="result_arrow">
      </div>
    </div>

    <!-- City search results -->
    <div class="results_list" *ngIf="viewState === 'search' && citySearch">
      <div class="result_item pointer"
           *ngFor="let city of cities"
           (click)="selectCityFromSearch(city)">
        <img src="assets/images/icons/location_Icon_for_mat_options.svg" class="result_icon">
        <div class="result_text">
          <span class="result_main">{{ city.name }}</span>
        </div>
        <img src="assets/images/icons/navbar/arrow_left_icon.svg" class="result_arrow">
      </div>
    </div>

    <!-- Checkbox (map state only) -->
    <div class="checkbox_section" *ngIf="viewState === 'map'">
      <label class="checkbox pointer">
        <input type="checkbox" [(ngModel)]="citySearch" (ngModelChange)="toggleCitySearch($event)">
        <span class="checkmark" [ngClass]="{checked: citySearch}">
          <img src="assets/images/icons/checkbox_icon.svg">
        </span>
      </label>
      <div class="checkbox_text ml_16">
        <div class="checkbox_title">{{ 'address.confirm_address_with_recipient' | translate }}</div>
        <div class="checkbox_subtitle mt_4">{{ 'address.enter_city_only' | translate }}</div>
      </div>
    </div>

  </div>

  <!-- Confirm button — always pinned at bottom, visible in map state -->
  <div class="bottom_bar" *ngIf="viewState === 'map'">
    <button class="confirm_button pointer"
            [ngClass]="{disabled: !selectedAddressOrCity}"
            [disabled]="!selectedAddressOrCity"
            (click)="confirm()">
      {{ 'buttons.confirm' | translate }}
    </button>
  </div>

</div>
